import { render, staticRenderFns } from "./LocalNotificationPrompt.vue?vue&type=template&id=5edc5e91&scoped=true"
import script from "./LocalNotificationPrompt.vue?vue&type=script&lang=js"
export * from "./LocalNotificationPrompt.vue?vue&type=script&lang=js"
import style0 from "./LocalNotificationPrompt.vue?vue&type=style&index=0&id=5edc5e91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc5e91",
  null
  
)

export default component.exports